<template>
  <FITFormCard>
    <div slot="header">
      <b-row>
        <b-col cols=8>
          <p class="h5">{{$t('crm.customer.header')+" "+$t('crm.customer.customerList')}}</p>
        </b-col>
        <b-col cols="4" class="text-right">
          <b-button v-if="permissionLevel < 5.5" variant="primary" size="md" @click="createNewCustomer">{{ $t('crm.customer.create.header') }}</b-button>
        </b-col>
      </b-row>
    </div>
    <div slot="formBody">
      <b-alert variant="success" dismissible :show="shouldShowSuccessMessage">
        <span class="h5"><i class="fa fa-check-circle mr-2"></i>{{ $t('crm.customer.create.success') }}</span>
      </b-alert>
      <!--  <b-row>
        <b-col cols="6">
          <FITTextInput :label="$t('crm.customer.search')" :placeholder="$t('crm.customer.search')" v-model="search"></FITTextInput>
        </b-col>
        <b-col cols="6">
          <FITPagination :disabled="busy" :totalRows="data.total" :perPage="pagination.perPage" size="md" @input="onPageChanged" v-model="pagination.currentPage"></FITPagination>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table outlined hover responsive striped :items="data.list" :fields="fields" tbody-tr-class="py-2 my-2">
            <template slot="customerCode" slot-scope="row">
              {{ row.value }}
            </template>
            <template slot="customerName" slot-scope="row">
              <span>{{ row.item.englishFirstname }} {{ row.item.englishLastname }}</span>
              <br/>
              <span>{{ row.item.chineseLastname }}{{ row.item.chineseFirstname }}</span>
            </template>
            <template slot="gender" slot-scope="row">
              {{ gender[row.value] }}
            </template>
            <template slot="currentAgent" slot-scope="row">
              <span>{{ row.item.currentAgentEnglishName }}</span>
              <br/>
              <span>{{ row.item.currentAgentChineseName }}</span>
            </template>
            <template slot="generalPolicyCount" slot-scope="row">
              <b-button :disabled="row.value == 0" variant="primary" size="sm">{{ $t('crm.customer.list.generalPolicyCount', { count: row.value }) }}</b-button>
            </template>
            <template slot="lifePolicyCount" slot-scope="row">
              <b-button :disabled="row.value == 0" variant="primary" size="sm">{{$t('crm.customer.list.lifePolicyCount', { count: row.value }) }}</b-button>
            </template>
            <template slot="ID" slot-scope="row">
              <b-button variant="primary" size="sm" @click="onRowSelected(row.item.ID)">
                <span><i class="fa fa-edit"></i> {{ $t('crm.edit') }}</span>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="6" class="text-left">
          <span class="text-secondary">{{ total }}</span>
        </b-col>
        <b-col cols="6" class="text-right">
          <FITPagination :disabled="busy" :totalRows="data.total" :perPage="pagination.perPage" size="md" @input="onPageChanged" v-model="pagination.currentPage"></FITPagination>
        </b-col>
      </b-row> -->
      <FITSearchableTable :filters="filters" :actions="actions" :columns="columns" searchAction="getCustomerList" vuexModule="Crm" type="customer" @onRowSelected="onRowSelected"></FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
import {
  FITPagination,
  FITFormCard,
  FITSelect,
  FITButton,
  FITTextInput,
  FITDatePicker,
  FITSearchableTable
} from '@/components';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'LeadList',
  components: {
    FITPagination,
    FITFormCard,
    FITSelect,
    FITButton,
    FITTextInput,
    FITDatePicker,
    FITSearchableTable
  },
  data() {
    return {

      filters: [{
        label: this.$t('general.gender'),
        key: 'gender',
        type: 'select',
        default: null, // Default All
        options: [
          { text: this.$t('general.all'), value: null },
          { text: this.$t('general.M'), value: 'M' },
          { text: this.$t('general.F'), value: 'F' },
        ]

      }],
      columns: [
        { key: 'customerCode', label: this.$t('crm.customer.create.customerCode') },
        {
          key: 'customerName',
          label: this.$t('crm.customer.customerName'),
          formatter: (row, key, item) => {
            return item.englishLastname + " " + item.englishFirstname + "</br>" + item.chineseLastname + item.chineseFirstname;
          }
        },
        {
          key: 'gender',
          label: this.$t('crm.customer.create.gender'),
          sortable: true,
          formatter: (row, key, item) => {
            if (!row || row == 'N') { return "N/A"; }
            return this.$t('general.' + row);
          }
        },
        //   { key: 'currentAgent', label: this.$t('crm.customer.currentAgent'),
        // formatter: (row, key, item) => {
        //    return item.currentAgentEnglishName+"</br>"+item.currentAgentChineseName;
        //   }},
        {
          key: 'generalPolicyCount',
          label: this.$t('crm.customer.generalPolicyCount'),
          sortable: true,
          thClass: ['text-center'],
          tdClass: ['text-center'],
          formatter: (row, key, item) => {
            return this.$t('crm.customer.list.generalPolicyCount', { count: row });
          }
        },
        {
          key: 'lifePolicyCount',
          label: this.$t('crm.customer.lifePolicyCount'),
          sortable: true,
          thClass: ['text-center'],
          tdClass: ['text-center'],
          formatter: (row, key, item) => {
            return this.$t('crm.customer.list.lifePolicyCount', { count: row });
          }
        },

      ],
      actions: [
        // {
        //     text: this.$t('crm.customer.edit'),
        //     key: 'edit',
        //     callback: (key, row, instance) => {
        //       this.onRowSelected(row.ID);
        //     }
        //   }

      ],

      // search: null,

      // gender: {
      //   'M': 'Male',
      //   'F': 'Female'
      // },

      // data: {
      //   total: 0,
      //   list: []
      // },

      // pagination: {
      //   currentPage: 1,
      //   perPage: 20
      // },

      // fields: [
      //   { key: 'customerCode', label: this.$t('crm.customer.create.customerCode'), class: "align-middle" },
      //   { key: 'customerName', label: this.$t('crm.customer.customerName'), class: "align-middle" },
      //   { key: 'gender', label: this.$t('crm.customer.create.gender'), class: "align-middle" },
      //   { key: 'currentAgent', label: this.$t('crm.customer.currentAgent'), class: "align-middle" },
      //   { key: 'generalPolicyCount', label: this.$t('crm.customer.generalPolicyCount'), class: 'text-center align-middle' },
      //   { key: 'lifePolicyCount', label: this.$t('crm.customer.lifePolicyCount'), class: 'text-center align-middle' },
      //   { key: 'ID', label: this.$t('crm.customer.edit'), class: 'text-center align-middle' },
      // ],

      busy: false,
      timeout: null,
      shouldShowSuccessMessage: false
    }
  },

  props: {
    createSuccess: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    // total() {
    //   return `${this.$t('crm.lead.page')} ${this.pagination.currentPage} / ${this.$t('crm.lead.total')} ${this.data.total} ${this.$t('crm.lead.items')}`;
    // },
    ...mapGetters(['getTranslatedArray']),

  },

  watch: {
    // pagination: {
    //   deep: true,
    //   handler(val) {
    //     this.refreshPage();
    //   }
    // },

    // search: {
    //   handler(val) {
    //     if (this.busy) {
    //       return;
    //     }

    //     Vue.set(this, 'busy', true);
    //     if (timeout) {
    //       clearTimeout(this.timeout);
    //     }

    //     let timeout = setTimeout(() => {
    //       Vue.set(this, 'busy', false);
    //       Vue.set(this, 'timeout', null);
    //     }, 1500);

    //     this.refreshPage();
    //   },
    //   deep: true // watch nested
    // }
  },

  methods: {

    onRowClicked(row) {
      console.debug(row)
    },

    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Crm', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },


    createNewCustomer() {
      this.$router.push('/crm/customer/create');
    },

    onRowSelected(item) {

      this.$router.push({
        name: 'Create Customer',
        params: { ID: parseInt(item.ID) }
      });
    },

    //   onPageChanged(newPage) {
    //     // Vue.set(this.pagination, 'currentPage', newPage);
    //   },

    //   refreshPage() {
    //     let param = {};
    //     if (this.search != null && this.search.trim().length > 0) {
    //       param['search'] = this.search.trim();
    //     }

    //     this.$store.dispatch('Crm/getCustomerList', {
    //       page: this.pagination.currentPage,
    //       count: this.pagination.perPage,
    //       ...param
    //     }).then((json) => {
    //       console.debug(json);
    //       Vue.set(this, 'data', json);
    //     }).catch((err) => {
    //       console.error(err);
    //     });
    //   }
  },

  created() {
    // this.$store.dispatch('getAllSelections', 'lead')
    //   .then((json) => {
    //     this.$store.commit({ type: 'Crm/setSelections', selection: json.data });
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
    // this.refreshPage();
  },

  mounted() {

    if (this.createSuccess) {
      Vue.set(this, 'shouldShowSuccessMessage', true);
      setTimeout(() => {
        Vue.set(this, 'shouldShowSuccessMessage', false);
      }, 3000);
    }
  }
}

</script>
<style>
.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Customer/CustomerList.vue